import React from 'react';
import { formatString } from '../../Common/CommonVariables';
import { useTranslation } from 'react-i18next';


const Relationship = ({ nextStep, prevStep, handleChange, formData,error,step, totalSteps, isHighmarkPortal }) => {
  // const isNextEnabled = !!formData.relationshipStatus;
  const { t, i18n } = useTranslation();


  return (
    <div className="step-section">
      <h3 className="page-heading-secondary-black-500 mb-5">{t('relationship')}</h3>

      <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
        <input
          type="radio"
          className="form-check-input radio-btn win-form-check-input"
          id="relationship1"
          name="relationshipStatus"
          value={t('heterosexual')}
          checked={(formData.relationshipStatus) === t('heterosexual')}
          onChange={handleChange}
        />
        {console.log(formData.relationshipStatus)}
        <label for="relationship1" className="multistep-form-radio-checkbox-label">{t('heterosexual')}</label>
      </div>

      <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
        <input
          type="radio"
          className="form-check-input radio-btn win-form-check-input"
          id="relationship2"
          name="relationshipStatus"
          value={t('samesex')}
          checked={(formData.relationshipStatus) === t('samesex')}
          onChange={handleChange}
        />
        <label for="relationship2" className="multistep-form-radio-checkbox-label">{t('samesex')}</label>
      </div>

      <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
        <input
          type="radio"
          className="form-check-input radio-btn win-form-check-input"
          id="relationship3"
          name="relationshipStatus"
          value={t('nosingle')}
          checked={(formData.relationshipStatus) === t('nosingle')}
          onChange={handleChange}
        />
        <label for="relationship3" className="multistep-form-radio-checkbox-label">{t('nosingle')}</label>
      </div>

      <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
        <input
          type="radio"
          className="form-check-input radio-btn win-form-check-input"
          id="relationship4"
          name="relationshipStatus"
          value={t('complicated')}
          checked={(formData.relationshipStatus) === t('complicated')}
          onChange={handleChange}
        />
        <label for="relationship4" className="multistep-form-radio-checkbox-label">{t('complicated')}</label>
      </div>
      {error && <p className="text-danger">{error}</p>}
      <div className="mt-5">
      {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            <button className="previous-btn" onClick={prevStep}></button>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={nextStep}></button>
          </div>
        ) : (
          <div className="mt-5">
            <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>{t('back')}</button>
            <button className="win-btn-primary mobile-view" onClick={nextStep}>{t('next')}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Relationship;
